// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.60.0',
  commit: 'adda66b6c77e09fa531302301b67c5fa05d088ba',
  branch: 'platinum',
  dateGenerated: '2026-02-25T15:58:56.817Z',
};